<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 ziro-datatable-content">
    <ziro-breadcrumbs></ziro-breadcrumbs>

    @if (isLoading) {
      <ziro-loading-block></ziro-loading-block>
    } @else {
      <ziro-datatable
        class="ziro-card"
        [rowDataSource]="rows"
        [columns]="columns"
        [uniqueRowIdentifier]="'name'"
        [dataAutomation]="'tenant-privileges-table'"
        [showCustomAlert]="true"
        [noResultsAlertClass]="'table-warning'"
        [setColumnWidths]="false"
        [mainFilterPlaceholder]="'tkey;admin.privileges.table.filter'"
      >
        <ziro-datatable-multi-select-filter
          [label]="'tkey;admin.privileges.table.type'"
          [items]="typeFilterOptions"
          [dataAutomation]="'tenant-privileges-type-filter'"
          [tableId]="'tenant-privileges-table'"
          [matchFn]="isTypeMatch"
          [matchValue]="true"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;admin.privileges.table.role'"
          [items]="roleFilterOptions"
          [dataAutomation]="'tenant-privileges-role-filter'"
          [tableId]="'tenant-privileges-table'"
          [matchFn]="isRoleMatch"
          [matchValue]="true"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;admin.privileges.table.privilege'"
          [items]="privilegeFilterOptions"
          [dataAutomation]="'tenant-privileges-privilege-filter'"
          [tableId]="'tenant-privileges-table'"
          [matchFn]="isPrivilegeMatch"
          [matchValue]="true"
        ></ziro-datatable-multi-select-filter>
        <div alert-content [innerHtml]="'tkey;admin.tenant_privileges.table.no_data.message' | escapeHtml"></div>
      </ziro-datatable>
    }
  </div>
</div>
<ziro-bottom-nav></ziro-bottom-nav>
